<template>
  <div id="carousel">
    <div class="block fullSlide">
      <!-- <el-carousel height="500px"> -->
      <el-carousel height="500px">
        <el-carousel-item
          style="width: 100%; z-index: 0"
          v-for="item in bannerList"
          :key="item.id"
        >
          <!-- <a :href="item.bannerContent" target="_blank"> -->
            
          <a :href="item.bannerContent" target="_blank" :style="{'background-image': 'url(' + item.imageUrl + ')' }" class="bg_banner">
            <!-- <img :src="item.imageUrl" alt="" style="height: 100%;" /> -->
          </a>
        </el-carousel-item>
      </el-carousel>
      <div
        class="hd"
        style="height: 30px; position: absolute; bottom: 0; left: 0; z-index: 1"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Carousel",
  components: {},
  created() {},
  mounted() {
    this._getBanner();
  },

  data() {
    return {
      bannerList: [],
      page: {
        size: 10,
        page: 1,
        total: 0,
      },
    };
  },
  methods: {
    // banner图
    _getBanner() {
      let data = {
        pageSize: this.page.size,
        pageNumber: this.page.page,
      };
      this.$post(
        this.$store.state.CTP_BASE + "/portalBanner/getPortalBannerPage",
        data
      ).then((res) => {
        if (res.status == "0") {
          this.bannerList = res.data.dataList;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import "../style/global-style.css";
/deep/ .el-carousel__button {
  width: 10px;
  height: 10px;
  border-radius: 5px;
  border: 1px solid #108ee9;
}
/deep/ .el-carousel__indicators--vertical {
  top: 17%;
}
.el-carousel__item img{
  display: block;
  margin: 0 auto;
}
.bg_banner {
  // background: url();
  background-position: top center;
  background-repeat: no-repeat;
  height: 500px;
  display: block;
  background-size: 100% 100%;
}
@media (max-width: 1600px) {
    .el-carousel__item img{
      display: block;
      margin: 0 auto;
      width: 100%;
      height: 500px !important;
    }   
    
}
</style>


// WEBPACK FOOTER //
// src/components/Carousel.vue